module.exports = __webpack_public_path__ + "static/personal-30637aaccb001d6ce6f19ede6f1889e8.png";